export enum AdditionalServiceTypeEnum {
  Autogiro = 'autogiro',
  PaymentService = 'paymentService',
  OwnPayment = 'ownPayment',
  ActivateSpar = 'activateSpar',
  SupportPlus = 'supportPlus',
}
